// extracted by mini-css-extract-plugin
export default {"container":"ViewRequirement_container__JxC-h","fields":"ViewRequirement_fields__5c9e6"};